"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiRadioOverrides = void 0;
var colorManipulator_1 = require("@material-ui/core/styles/colorManipulator");
var createMuiRadioOverrides = function (_a) {
    var spacing = _a.spacing, palette = _a.palette, transitions = _a.transitions;
    return ({
        root: {
            padding: "calc(" + spacing(4) + "px - 0.75rem)",
            borderRadius: "50%",
            "& [class*='MuiSvgIcon-root']": {
                transition: transitions.create(["fill", "stroke", "color", "background-color"], {
                    duration: transitions.duration.shorter,
                }),
            },
        },
        colorPrimary: {
            "& [class*='MuiSvgIcon-root']": {
                stroke: palette.text.secondary,
            },
            "&&$checked [class*='MuiSvgIcon-root']": {
                color: palette.common.white,
                fill: palette.primary.main,
                stroke: palette.background.default,
            },
            "&:hover, &&$checked:hover, &.Mui-focusVisible": {
                backgroundColor: palette.action.hover,
            },
            "&.Mui-focusVisible [class*='MuiSvgIcon-root']": {
                stroke: palette.text.primary,
            },
            "&:active, &&$checked:active": {
                backgroundColor: colorManipulator_1.alpha(palette.text.primary, 0.24),
            },
            "&$disabled": {
                color: palette.text.primary,
            },
        },
        disabled: {
            opacity: palette.action.disabledOpacity,
        },
    });
};
exports.createMuiRadioOverrides = createMuiRadioOverrides;
//# sourceMappingURL=MuiRadio.js.map